import {
  appModalOpen,
  projectGet,
} from 'actions';
import { connect } from 'react-redux';
import View from './';


const mapStateToProps = state => ({
  modals: state.app.modals,
});

const mapDispatchToProps = (dispatch) => {
  return {
    appModalOpen(payload) {
      dispatch(appModalOpen(payload));
    },
    projectGet(payload) {
      return dispatch(projectGet(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/systems/detail/container.js